import classNames from 'classnames'
import React, { ReactNode } from 'react'

import { isHyphenatedLocale } from '../../locale/i18n'
import Heading from '../Heading'

export type BackgroundColor = 'none' | 'light' | 'blue'

export interface SectionProps {
  id?: string
  className?: string
  backgroundColor?: BackgroundColor
  children?: React.ReactNode
  isRelative?: boolean
  title?: string | ReactNode
  image?: ReactNode
  flip?: boolean
}

const bgColorMap: Record<BackgroundColor, string> = {
  blue: 'bg-secondary-light2',
  light: 'bg-secondary-light',
  none: 'bg-transparent',
}

const Section = ({
  id,
  className,
  backgroundColor = 'none',
  isRelative,
  title,
  image,
  flip,
  children,
}: SectionProps) => {
  return (
    <section
      id={id}
      className={classNames(
        'text-color py-12 md:py-18',
        bgColorMap[backgroundColor],
        { relative: isRelative },
        className,
      )}
    >
      <div
        className={classNames(
          'mx-auto flex max-w-screen-xl flex-col items-center gap-32 px-4 md:flex-row',
          {
            hyphenate: isHyphenatedLocale(),
          },
        )}
      >
        {image ? (
          <div
            className={classNames(
              'order-1 flex-1 shrink justify-center align-middle',
              flip ? 'md:order-0' : '',
            )}
          >
            {image}
          </div>
        ) : null}
        <div className="mt-6 flex-2 [&_p+p]:mt-8">
          {typeof title === 'string' ? <Heading text={title} /> : title}
          {children}
        </div>
      </div>
    </section>
  )
}

export default Section
